export enum FormatsEnums {
  //Formatos
  invoice = 1,
  inventoryEntry = 5,
  inventoryOutput = 6,
  subrentalEntry = 7,
  subrentalOutput = 8,
  inventoryTransfer = 9,
  remission = 10,
  devolution = 20,
  service = 30,
  suspension = 40,
  transferConstructionSite = 45,
  order = 50,
  predevolution = 60,
  transferStoreWorkshop = 70,
  transferWorkshopStore = 80,
  quotation = 85,
  maintenanceOrderSite = 90,
  maintenanceRoutine = 93,
  maintenanceOrderScheduled = 95,
  notes = 100,
  maintenanceOrderWorkshop = 140,
  chargeAccount = 150,
  preinvoicing = 160,
  cashReceipt = 180,
  documentSupport = 190,
  internalOrder = 195,
  purchaseOrder = 200,
  simpleEquipmentLogbook = 210,
  valuedEquipmentLogbook = 220,
  salesRemission = 15,
  liquidation = 230,
  costAdjustment = 18,
  requestNote = 120
}

export enum PaperSizeEnums {
  letter = 1,
  halfLetter = 5,
}